var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4047 12.3008C15.4264 10.6198 16.3292 9.02922 17.7613 8.14876C16.8578 6.85844 15.3445 6.04034 13.7701 5.99108C12.0909 5.81482 10.4629 6.99591 9.60723 6.99591C8.73497 6.99591 7.41746 6.00858 5.99873 6.03777C4.14948 6.09751 2.42551 7.1489 1.52581 8.76564C-0.408185 12.1141 1.0344 17.0351 2.88701 19.7417C3.81391 21.0671 4.89719 22.5475 6.31464 22.495C7.7017 22.4375 8.21974 21.6105 9.89404 21.6105C11.5528 21.6105 12.0388 22.495 13.485 22.4616C14.9734 22.4375 15.9112 21.1304 16.8056 19.7925C17.4715 18.8481 17.984 17.8044 18.324 16.7C16.5749 15.9602 15.4068 14.2 15.4047 12.3008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6731 4.21108C13.4846 3.23687 13.8844 1.98469 13.7876 0.720459C12.5478 0.850679 11.4025 1.44324 10.58 2.38007C9.77573 3.2954 9.35717 4.52555 9.4363 5.74146C10.6766 5.75423 11.8959 5.17773 12.6731 4.21108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreLogo);
export default __webpack_public_path__ + "static/media/appStoreLogo.d0599ccb6074d894ac483f4f45a14f78.svg";
export { ForwardRef as ReactComponent };